import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

const MainLayout = ({ children, showSidebar = true }) => {
  const [isSidebarVisible, setSidebarVisible] = useState(
    sessionStorage.getItem("sidebarVisible") === "true"
  );

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
    sessionStorage.setItem("sidebarVisible", !isSidebarVisible);
  };

  // useEffect(() => {
  //   const mediaQuery = window.matchMedia("(min-width: 1025px)");
  //   setSidebarVisible(mediaQuery.matches);

  //   const handleResize = () => {
  //     setSidebarVisible(mediaQuery.matches);
  //   };

  //   mediaQuery.addEventListener("change", handleResize);

  //   return () => {
  //     mediaQuery.removeEventListener("change", handleResize);
  //   };
  // }, []);

  return (
    <div>
      <Header toggleSidebar={toggleSidebar} />
      <div className="flex w-full h-[calc(100vh-80px)]">
        {isSidebarVisible && (
          <Sidebar
            hideSidebarOnclick={() => {
              setSidebarVisible(false);
            }}
          />
        )}
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
